<div class="page-section">
    <div class="page-section-header">
        <h2 class="page-section-title">Agent Level Purchase ({{status == 'pending' ? 'Pending Approval' : status == 'paid' ? 'Approved' : 'Rejected'}})</h2>
    </div>
    <div class="page-section-filters">
        <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 'pending'" (click)="getRequests('pending')">Pending</button>
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 'paid'" (click)="getRequests('paid')">Approved</button>
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 'rejected'" (click)="getRequests('rejected')">Rejected</button>
        </div>
    </div>
    <div class="page-section-body">
        <table class="table">
            <thead>
                <tr>
                    <th>No</th>
                    <th>Upline Agent</th>
                    <th>New Agent</th>
                    <th>Level</th>
                    <th>Rate</th>
                    <th>Price</th>
                    <th>Credit</th>
                    <th *ngIf="status == 'paid'">Created Code</th>
                    <th *ngIf="status == 'rejected'">Reason</th>
                    <th *ngIf="status == 'pending'">Proof</th>
                    <th *ngIf="status == 'pending'">Decision</th>
                    <th *ngIf="status == 'pending'">Action</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let request of requests; let i = index">
                    <td>{{i+1}}</td>
                    <td>
                        <div>{{request.upline_code}}</div>
                        <div class="text-muted small">{{request.upline_name}}</div>
                    </td>
                    <td>
                        <div>{{request.pending_name}}</div>
                        <div class="text-muted small">{{request.pending_fullname}}</div>
                        <div class="text-muted small">{{request.pending_mobile}}</div>
                    </td>
                    <td>{{request.level_title}}</td>
                    <td>{{request.rate | number: '1.0-2'}}%</td>
                    <td>{{request.price | number: '1.2-2'}}</td>
                    <td>{{request.credit | number: '1.2-2'}}</td>
                    <td *ngIf="status == 'paid'">{{request.new_agent_code || '-'}}</td>
                    <td *ngIf="status == 'rejected'">{{request.remark}}</td>

                    <!-- Pending: bank-transfer proof uploaded by the agent (if any) -->
                    <td *ngIf="status == 'pending'">
                        <a *ngIf="request.proof_url" [href]="request.proof_url" target="_blank">
                            <img src="{{request.proof_url}}" class="img-fluid" style="max-height: 80px;">
                        </a>
                        <span *ngIf="!request.proof_url" class="text-muted small">—</span>
                    </td>

                    <!-- Pending: approve / reject decision -->
                    <td *ngIf="status == 'pending'">
                        <select class="form-select form-select-sm" [(ngModel)]="request.action_status">
                            <option value="paid">Approve</option>
                            <option value="rejected">Reject</option>
                        </select>
                        <input *ngIf="request.action_status == 'rejected'" type="text" class="form-control form-control-sm mt-2" placeholder="Reason" [(ngModel)]="request.remark">
                    </td>

                    <td *ngIf="status == 'pending'">
                        <button class="btn btn-primary btn-sm" (click)="updateRequest(request)">UPDATE</button>
                    </td>
                    <td>{{request.create_on | date:'dd/MM/yyyy HH:mm'}}</td>
                </tr>
                <tr *ngIf="requests.length == 0 && !is_loading">
                    <td colspan="100%" class="text-center text-muted py-4" style="font-style: italic;">No data found</td>
                </tr>
                <tr *ngIf="is_loading">
                    <td colspan="100%" class="text-center text-muted py-4" style="font-style: italic;">Loading...</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="page-section-footer" *ngIf="!is_loading && requests.length > 0">
        <span>Total Orders:</span>
        <span class="page-section-stat">{{requests.length}}</span>
    </div>
</div>
